export const NotificationTemplateKey = 'notification-templates';
export const SendGridTemplateKey = 'sendgrid-templates';